import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { StringDateRange, ValType } from '../move_me/StringDateRange';
import { MFieldProps } from '../types';
import { FormItem } from './FormItem';

type Props = {
  onChange?: (val: ValType) => void;
  onBlur?: (val: ValType) => void;
} & MFieldProps<React.ComponentProps<typeof StringDateRange>>;

export const DateRange: React.FC<Props> = ({
  name,
  validate,
  //label,
  onChange: $onChange,
  onBlur: $onBlur,
  className,
  disabled,
  required,
  ...other
}) => {
  return (
    <FormItem
      name={name}
      className={className}
      disabled={disabled}
      required={required}
    >
      <Field name={name} validate={validate}>
        {({ input: { onChange, value } }: FieldRenderProps<string[]>) => (
          <StringDateRange
            value={value}
            onChange={(value) => {
              onChange({ target: { name, value: value } });
              $onChange && $onChange(value);
            }}
            onBlur={(value) => {
              $onBlur && $onBlur(value);
            }}
            {...other}
            disabled={disabled}
          />
        )}
      </Field>
    </FormItem>
  );
};
